(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mo-tide-oracle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mo-tide-oracle')) {
    customElements.define(
      'mo-tide-oracle',
      class extends HTMLElement {
        connectedCallback() {
          this.cards = [...this.querySelectorAll('[data-oracle-card]')];
          this.front = this.querySelector('[data-oracle-front]');
          this.deck = this.querySelector('[data-oracle-deck]');
          this.status = this.querySelector('[data-oracle-status]');
          this.lastIndex = -1;
          this.addEventListener('click', (event) => {
            if (event.target.closest('[data-oracle-draw]')) this.draw();
          });
        }

        draw() {
          if (!this.cards.length) return;
          let nextIndex = Math.floor(Math.random() * this.cards.length);
          if (this.cards.length > 1 && nextIndex === this.lastIndex) {
            nextIndex = (nextIndex + 1 + Math.floor(Math.random() * (this.cards.length - 1))) % this.cards.length;
          }
          this.lastIndex = nextIndex;
          this.cards.forEach((card, index) => {
            card.hidden = index !== nextIndex;
          });
          this.front.hidden = true;
          this.deck.hidden = false;
          const title = this.cards[nextIndex].querySelector('.mo-oracle__product-line span')?.textContent.trim();
          this.status.textContent = title ? `The tide chose ${title}.` : '';
          this.deck.classList.remove('mo-oracle__deck--enter');
          requestAnimationFrame(() => this.deck.classList.add('mo-oracle__deck--enter'));
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
